import { api } from '@/core/api/';

const baseUrl = '/api/users';

//ECG:filters contiene {name:'nombredefiltro', value:'valordelfiltro'}
export const getUsersSearchResults = (filters) => {
  return api.get(`${baseUrl}`, {
    params: filters,
  });
};

export const addNewUser = (newUser) => {
  try {
    return api.post(`${baseUrl}`, newUser);
  } catch (error) {
    return error;
  }
};

export const activateUser = (user) => {
  try {
    return api.post(`${baseUrl}/activateuser`, user);
  } catch (error) {
    return error;
  }
};

export const addUserFromRequest = (
  accountRequestId,
  username,
  authenticationMode
) =>
  api.post(
    `${baseUrl}/${accountRequestId}`,
    { username, authenticationMode },
    { params: { username, authenticationMode } }
  );

export const getParentCatalogues = async () =>
  api.get(`${baseUrl}/parentportalcatalogues`);

export const getUser = async (userId) => {
  try {
    const { data } = await api.get(`${baseUrl}/` + userId);
    return data;
  } catch (error) {
    return error;
  }
};

export const getByUserName = async (userName) => {
  try {
    const { data } = await api.get('/api/users/username/' + userName);
    return data;
  } catch (error) {
    return error;
  }
};

export const getSipaeeTutorStudents = async (userId) => {
  const { data } = await api.get(`${baseUrl}/tutor/${userId}/students`);
  return data;
};

export const getBasicSipaeeStudentInformation = async (studentSieId) => {
  const { data } = await api.get(`${baseUrl}/sipaeestudent/${studentSieId}`);
  return data;
};

export const getSipaeeDistricts = async () => {
  const { data } = await api.get(`${baseUrl}/sipaee/districts`);
  return data;
};
export const getSiPaeeRegions = async () => {
  const { data } = await api.get(`${baseUrl}/sipaee/regions`);
  return data;
};
export const getSipaeeMunicipalities = async () => {
  const { data } = await api.get(`${baseUrl}/sipaee/municipalities`);
  return data;
};

export const getUserLocations = async (userId) => {
  const { data } = await api.get(
    `${baseUrl}/user/${userId}/locations`
  );
  return data;
};

export const updateUser = async (userData) => {
  try {
    return api.put(`${baseUrl}/` + userData.userId, userData);
  } catch (error) {
    return error;
  }
};

export const validateUserHasDigitalSignature = async (userData) => {
  try {
    return api.get(`${baseUrl}/` + userData.userId + '/hasDigitalSignatures');
  } catch (error) {
    return error;
  }
};

export const updateUserPermissions = async (userData) => {
  try {
    return api.put(`${baseUrl}/${userData.userId}/permissions`, userData);
  } catch (error) {
    return error;
  }
};

export const unlockUser = async (username) => {
  try {
    return api.get(`${baseUrl}/` + username + '/unlock');
  } catch (error) {
    return error;
  }
};

export const resendActivationNotification = async (
  userId,
  applicationsList
) => {
  try {
    return api.get(`${baseUrl}/` + userId + '/resendActivation', {
      params: {
        applicationsList,
      },
    });
  } catch (error) {
    return error;
  }
};

export const getPermissionsForUser = (data) =>
  api.put(`${baseUrl}/permissionsinuser`, data);

export const deleteUser = async (userId) => {
  try {
    return api.put(`${baseUrl}/delete/${userId}`);
  } catch (error) {
    return error;
  }
};

export const getUsersWithSameEmail = async (userId, email) => {
  try {
    return api.get(`${baseUrl}/userswithsameemail/${email}`, {
      params: { userId: userId },
    });
  } catch (error) {
    return error;
  }
};

export const consolidateUserAccount = async (userToKeepId, userToDeleteId) => {
  try {
    return api.post(`/api/users/${userToKeepId}/consolidate/${userToDeleteId}`);
  } catch (error) {
    return error;
  }
};

export const getUserActivity = (userId) =>
  api.get(`${baseUrl}/activityhistory/${userId}`);

export const existsUserRoleSummerTeacher = () =>
  api.get(`${baseUrl}/existsuserrolesummerteacher`);

export const changeUserRoleTeacher = () =>
  api.post(`${baseUrl}/changeuserroleteacher`);

export const removeContract = (contractId, isMediator = false) =>
  api.delete(`${baseUrl}/contracts/${contractId}`, {
    params: { isMediator },
  });

export const updateContract = (contractId, userId, model) =>
  api.put(`${baseUrl}/user/${userId}/contract/${contractId}`, model);

export const getContracts = (userId) =>
  api.get(`${baseUrl}/${userId}/contracts`);

export const getLocations = () =>
  api.get(`${baseUrl}/locations`);

export const getAllLocations = (companyId) =>
  api.get(`${baseUrl}/alllocations/${companyId}`);

export const createDESpecialist = async (userId) =>
  await api.post(`${baseUrl}/createdespecialist/${userId}`);
